import { TrackingHandler } from '../tracking/TrackingHandler';
import { getCss, getScript } from './get-resource';
import { getUrlParameter } from './browser';
import { isMobile } from './detect-mobile';
const EXPERIMENT_NAME = 'chat';
const EXPERIMENT_VARIATIONS = ['active', 'inactive'];
const CHAT_WIDGET_TIMEOUT = 10000;
const loadSnapEngageChat = async () => {
    const trackingHandler = TrackingHandler.getInstance();
    if (trackingHandler.isCustomer) {
        return;
    }
    window.initSnapEngage();
};
const loadAidaChat = async () => {
    if (isMobile()) {
        return;
    }
    const trackingHandler = TrackingHandler.getInstance();
    await trackingHandler.consentGranted('essential');
    const container = document.createElement('div');
    container.id = 'web-chat-widget';
    document.body.appendChild(container);
    window.webChatWidgetTitle = 'Chat';
    window.webChatWidgetSubtitle = '';
    window.webChatWidgetChannelId = window.siteSettings.aidaChannelId;
    window.webChatWidgetPopBehavior = 'silent';
    window.webChatWidgetTheme = 'default';
    window.webChatWidgetLanguageId = (window.siteSettings.aidaLanguageId || 1).toString();
    window.webChatWidgetToken = window.siteSettings.aidaToken || 'default';
    window.webChatWidgetCloseButton = false;
    if (typeof window.siteStyles === 'object' && typeof window.siteStyles['color-primary'] === 'string') {
        window.webChatWidgetTheme = window.siteStyles['color-primary'];
    }
    await Promise.all([
        getCss(window.endpoints.webChatDomain + '/static/css/web-chat-widget.css'),
        getScript(window.endpoints.webChatDomain + '/static/js/web-chat-widget.js', 'anonymous'),
    ]);
    if (typeof window.startWebChatWidget === 'undefined' || typeof window.checkChatAgentAvailability$ === 'undefined') {
        return;
    }
    if (window.isWebChatWidgetActive) {
        window.startWebChatWidget(trackingHandler.getAllTrackingData());
        window.page.chatType = 'aida';
        return;
    }
    if (getUrlParameter('ignoreAIDAAgentAvailability') !== null || (await window.checkChatAgentAvailability$())) {
        window.setTimeout(() => {
            window.startWebChatWidget(trackingHandler.getAllTrackingData());
            window.page.chatType = 'aida';
        }, CHAT_WIDGET_TIMEOUT);
    }
};
export const initChat = async () => {
    if (typeof window.siteSettings !== 'object') {
        return;
    }
    const snapEngageAvailable = typeof window.siteSettings.snapEngageWidgetId === 'string' &&
        typeof window.initSnapEngage === 'function' &&
        (window.siteSettings.enableSnapEngage || getUrlParameter('enableSnapEngage'));
    const aidaAvailable = typeof window.siteSettings.aidaChannelId === 'string' &&
        (window.siteSettings.enableAIDA || getUrlParameter('enableAIDA'));
    if (!snapEngageAvailable && !aidaAvailable) {
        return;
    }
    const variation = await TrackingHandler.getInstance().getExperimentVariation(EXPERIMENT_NAME, EXPERIMENT_VARIATIONS);
    if (variation !== 'active') {
        return;
    }
    if (aidaAvailable) {
        await loadAidaChat();
        return;
    }
    if (snapEngageAvailable) {
        await loadSnapEngageChat();
        return;
    }
};
